<template>
  <v-card flat>
    <v-row justify="space-between" align="end">
      <v-col cols="auto">
        <span class="text-h6 font-weight-bold">
          {{ $t("users_and_ordered_meals") }}
        </span>
      </v-col>
      <v-col cols="auto">
        <shift-picker v-model="selectedShift" :items="shifts" />
      </v-col>
    </v-row>
    <v-row>
      <template v-if="loading">
        <v-col cols="12">
          <div class="text-center pa-4">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
            ></v-progress-circular>
            <div class="mt-2">{{ $t("loading") }}</div>
          </div>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12" md="4" v-for="(items, inx) in filterByShift" :key="inx">
          <div
            class="pa-4 fill-height rounded-lg"
            style="border: 1px solid rgba(0, 0, 0, 0.12)"
          >
            <p class="text-center">
              <span class="grey--text">#{{ items.id }}</span>
              <span class="font-weight-bold">
                {{ toLatin(items.name) + " " + toLatin(items.lastname) }}
              </span>
            </p>
            <div v-if="items.orders?.length">
              <p v-for="(item, index) in items.orders" :key="index">
                {{ item.quantity }}<span class="grey--text">x</span>
                {{ item.food?.name || "" }}
              </p>
            </div>
          </div>
        </v-col>
      </template>
    </v-row>
  </v-card>
</template>

<script>
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  mixins: [hasPrinting, hasExcel, hasReportPrinting],
  props: {
    users: {
      type: Array,
      required: true,
    },
    searchByShift: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedShift: null,
    };
  },
  computed: {
    filterByShift() {
      return this.users.filter((item) => {
        return item.order_count > 0 && item.shift === this.selectedShift;
      });
    },
    selectedCompanies() {
      return this.$store.state.report.selectedFoodCompanies
        .map((company) => company.name)
        .join(", ");
    },
    shifts() {
      return [...new Set(this.users.flatMap((item) => item.shift))];
    },
    headers() {
      return [
        { text: this.$t("name"), value: "name" },
        { text: this.$t("last_name"), value: "lastname" },
        ...this.mealCategories.map((category) => ({
          text: this.translate(category),
          value: category,
        })),
      ];
    },
    mealCategories() {
      return this.users.reduce((acc, user) => {
        (user.orders || []).forEach((order) => {
          if (order.food?.category?.name && !acc.includes(order.food.category.name)) {
            acc.push(order.food.category.name);
          }
        });
        return acc;
      }, []);
    },
  },
  watch: {
    isPrinting() {
      if (this.isPrinting) {
        let appendHtml = `<div style='display: flex;flex-wrap: wrap;'>`;
        this.filterByShift.forEach((user) => {
          appendHtml += `<div style='flex: 0 0 50%;box-sizing: border-box;padding: 12px;border: 1px solid #ccc;'>
          <h3 style="text-align:center;margin-top: 0"><small style="color: #999">#${user.id}</small> ${this.toLatin(user.name)} ${this.toLatin(user.lastname)}</h3>`;
          (user.orders || []).forEach((order) => {
            if (order.food?.name) {
              appendHtml += `<p>${order.quantity + "x" || ""} ${this.toLatin(
                order.food?.name
              )}</p>`;
            }
          });
          appendHtml += `</div>`;
        });
        appendHtml += `</div>`;
        this.printDocument({
          title: this.$t("users_and_ordered_meals"),
          afterTableHtml: appendHtml,
          subtitle: this.subtitle,
          beforeTableHtml: `<h4 style="text-align: center">${this.selectedCompanies}</h4>`,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        const orders = this.users
          .filter((user) => user.order_count > 0 && user.shift === this.selectedShift)
          .map((user) => {
            this.mealCategories.forEach((category) => {
              const categoryOrders = (user.orders || [])
                .filter((order) => order.food?.category?.name === category)
                .map((order) => {
                  return order.quantity + "x " + this.translate(order.food?.name);
                })
                .join(", ");
              user[category] = categoryOrders || "";
            });
            return user;
          });
        this.downloadExcel({
          fileName: this.$t("users_and_ordered_meals") + ".xlsx",
          sheets: [
            {
              name: this.$t("user_overview"),
              headers: this.headers,
              items: orders,
              title: this.$t("users_and_ordered_meals"),
              subtitle: this.subtitle,
              beforeTableHtml: `<h4 style="text-align: center">${
                this.selectedCompanies || ""
              }</h4>`,
            },
          ],
        });
      }
    },
    shifts: {
      handler() {
        if (this.shifts.length) {
          this.selectedShift = this.shifts[0];
        } else {
          this.selectedShift = null;
        }
      },
      immediate: true,
    },
  },
};
</script>
